import { gql } from '@apollo/client';

import { ASSET2_FRAGMENT } from '../../../../common/AdForm/hooks/fragments/asset2Fragment';

export const GET_ASSETS_2_BY_IDS = gql`
  query getAssets2Data($assetIdList: [String!]!) {
    getAsset2ByIDs(assetIdList: $assetIdList) {
      ...asset2Fragment
    }
  }
  ${ASSET2_FRAGMENT}
`;
